<div class="status-dot-container">
    @if(status){
    <div class="status-dot" [ngClass]="status.toLowerCase()">
    </div>
    }
</div>